import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useId } from 'react-id-generator';
import { useAccordionDndContext } from '../AccordionDndContext/AccordionDndContext.js';
import { AccordionDroppable } from '../AccordionDroppable/AccordionDroppable.js';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);
var AccordionContext = function AccordionContext(_ref) {
  var children = _ref.children,
    defaultIndex = _ref.defaultIndex,
    droppableGroup = _ref.droppableGroup,
    droppableId = _ref.droppableId,
    _ref$exclusive = _ref.exclusive,
    exclusive = _ref$exclusive === void 0 ? false : _ref$exclusive,
    indexes = _ref.indexes,
    initialIndexes = _ref.initialIndexes,
    _ref$nonDestructive = _ref.nonDestructive,
    nonDestructive = _ref$nonDestructive === void 0 ? false : _ref$nonDestructive,
    onChange = _ref.onChange,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "sidepanel" : _ref$variant;
  var _React$useState = React.useState(validateIndexes(defaultIndex || initialIndexes, exclusive)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    openPanels = _React$useState2[0],
    setOpenPanels = _React$useState2[1];
  var _useId = useId(1, "accordion-"),
    _useId2 = _slicedToArray(_useId, 1),
    id = _useId2[0];
  var dndContext = useAccordionDndContext();
  React.useEffect(function () {
    if (Array.isArray(indexes)) {
      setOpenPanels(validateIndexes(indexes, exclusive));
    }
  }, [exclusive, indexes]);
  var onSelect = React.useCallback(function (index) {
    setOpenPanels(function (prevOpenPanels) {
      var nextState;
      if (prevOpenPanels.includes(index)) {
        nextState = prevOpenPanels.filter(function (i) {
          return i !== index;
        });
      } else if (exclusive) {
        nextState = [index];
      } else {
        nextState = [].concat(_toConsumableArray(prevOpenPanels), [index]);
      }
      if (typeof onChange === "function") {
        onChange(nextState);
      }
      return nextState;
    });
  }, [exclusive, onChange]);
  var context = React.useMemo(function () {
    return {
      accordionId: id,
      defaultIndex: defaultIndex,
      nonDestructive: nonDestructive,
      onSelect: onSelect,
      openPanels: openPanels,
      variant: variant
    };
  }, [id, defaultIndex, nonDestructive, onSelect, openPanels, variant]);
  if (dndContext) {
    return /*#__PURE__*/jsx(Context.Provider, {
      value: context,
      children: /*#__PURE__*/jsx(AccordionDroppable, {
        droppableId: droppableId,
        droppableGroup: droppableGroup,
        children: children
      })
    });
  }
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: children
  });
};
AccordionContext.displayName = "AccordionContext";
function useAccordionContext() {
  var accordionContext = React.useContext(Context);
  if (!accordionContext) {
    throw new TypeError("No AccordionContext provided.");
  }
  return accordionContext;
}
function validateIndexes(indexes, exclusive) {
  var indices = indexes || [];
  if (exclusive && indices && indices.length > 1) {
    console.warn("AccordionContext: The 'exclusive' prop is 'true' but I received multiple indexes to expand. Only the first index will be expanded.");
    indices = [indices[0]];
  }
  return indices;
}

export { AccordionContext, useAccordionContext };
